/**
 *
 * @subscribes cart-add-product <cart-fragment> <cart-item-id>
 *
 */

var sw = require('./../sw');

var _gaq = window._gaq || [];

sw.on('cart-add-product', function(fragment, itemId) {

  if (sw.data.shopTrackingCode && itemId) {
    _gaq.push(['b._setAccount', window.sw.data.shopTrackingCode]);
    _gaq.push(['b._trackEvent', 'Product', 'AddToCart', itemId]);
  }

});
